import { Button, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { Filters } from '@pelicargo/utils';
import { HiChevronLeft } from 'react-icons/hi';

import { trpc } from '../../config/trpc';
import { RequestFilters } from '../../hooks/useRequestFilters';

type Props = {
  filters: RequestFilters;
  handleRadioFilterChange: (key: string) => (nextValue: string) => void;
  resetView: () => void;
};

export const ClassificationFilter = ({ filters, handleRadioFilterChange, resetView }: Props) => {
  const { data: requestClassifications } = trpc.getFilters.useQuery({
    scope: Filters.SCOPES.requestClassification,
  });

  return (
    <Stack spacing="2" pt="2">
      <Stack direction="row" align="center" spacing="2">
        <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
          Request Classification
        </Button>
      </Stack>

      <Stack>
        <RadioGroup value={filters.request_classification} onChange={handleRadioFilterChange('request_classification')}>
          {requestClassifications?.map((node) => (
            <Stack key={node.id} py="2">
              <Radio value={node.identifier}>{node.identifier}</Radio>
            </Stack>
          ))}
        </RadioGroup>
      </Stack>
    </Stack>
  );
};
